import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "flex items-center justify-center py-10" }, [
  /*#__PURE__*/_createVNode("div", { class: "inline-block absolute bg-white px-3 uppercase text-13 text-dark" }, "or"),
  /*#__PURE__*/_createVNode("hr", { class: "w-full border-menu-dark" })
], -1)
const _hoisted_2 = { class: "text-secondary mt-6 text-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GoogleAuthButton = _resolveComponent("GoogleAuthButton")
  const _component_BaseInput = _resolveComponent("BaseInput")
  const _component_BasePasswordInput = _resolveComponent("BasePasswordInput")
  const _component_BaseButton = _resolveComponent("BaseButton")
  const _component_Form = _resolveComponent("Form")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_GoogleAuthButton, { "button-type": "sign-in" }),
    _hoisted_1,
    _renderSlot(_ctx.$slots, "alert"),
    _createVNode(_component_Form, {
      onSubmit: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('submit'))),
      "validation-schema": _ctx.validationSchema
    }, {
      default: _withCtx(() => [
        _createVNode(_component_BaseInput, {
          modelValue: _ctx.localEmail,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.localEmail = $event)),
          name: "email",
          label: _ctx.$t('forms.sign-in.email.label'),
          placeholder: _ctx.$t('forms.sign-in.email.placeholder'),
          "input-classes": "w-full h-11",
          "is-valid": !_ctx.error
        }, null, 8, ["modelValue", "label", "placeholder", "is-valid"]),
        _createVNode(_component_BasePasswordInput, {
          modelValue: _ctx.localPassword,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.localPassword = $event)),
          class: "mt-4",
          name: "password",
          label: _ctx.$t('forms.sign-in.password.label'),
          placeholder: _ctx.$t('forms.sign-in.password.placeholder'),
          "input-classes": "w-full h-11",
          "is-valid": !_ctx.error,
          togglable: ""
        }, null, 8, ["modelValue", "label", "placeholder", "is-valid"]),
        _createVNode(_component_BaseButton, {
          type: "submit",
          class: "mt-5 px-14 w-full",
          size: "lg",
          outline: "",
          "loading-variant": "primary",
          loading: _ctx.loading
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('actions.sign-in')), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }, 8, ["validation-schema"]),
    _createVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.$t('forms.sign-in.forget-password')) + " ", 1),
      _createVNode(_component_router_link, {
        class: "text-link",
        to: { name: 'reset-password-request' }
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('forms.sign-in.reset')), 1)
        ]),
        _: 1
      })
    ])
  ], 64))
}